import { Controller } from '@hotwired/stimulus';

// The system share sheet (Web Share API), and the clipboard where there is
// none — every desktop browser, and any page not on https.
//
//   <button data-controller="share clipboard" data-action="share#share"
//           data-share-url-value="<%= url %>" data-share-title-value="<%= title %>"
//           data-clipboard-success-message-value="<%= t(".copied") %>">
//
// The fallback IS fire's clipboard controller on the same element (its
// tooltip or label beat), not a second copy of it. No clipboard there, the
// link is still copied, silently. urlValue defaults to this page.
export default class extends Controller {
  static values = { url: String, title: String, text: String };

  async share(event) {
    event.preventDefault();
    const url = this.urlValue || window.location.href;

    if (navigator.share) {
      try {
        return await navigator.share({ url, title: this.titleValue || undefined, text: this.textValue || undefined });
      } catch (error) {
        if (error.name === 'AbortError') return; // they closed the sheet
      }
    }

    const clipboard = this.application.getControllerForElementAndIdentifier(this.element, 'clipboard');
    if (!clipboard) return navigator.clipboard?.writeText(url);

    clipboard.textValue = url;
    clipboard.copy(event);
  }
}
